import { useState, useEffect } from "react";
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Tooltip } from "@mui/material";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getVesselEdgeTopologyProducts } from "../../actions/Users/authenticateDashboard";
import _ from "lodash";
import "./VesselSummary.css";
import onlineIcon from "../../asset/image/online.svg";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../utils/constants";
import SettingsIcon from '@mui/icons-material/Settings';
import NetworkTable, { ColumnConfig, ColumnType, NetworkTableRow } from "../../UserScreen/InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable";

import {
    LOCATION_ID_KEY, ID_KEY, NAME_KEY, TYPE_KEY,
    HARDWARE_VESION_KEY, SOFTWARE_VERSION_KEY, STATUS
} from "../../utils/constants";
import EdgeLinkIcon from "../../asset/image/EdgeLinkIcon.svg"
import EdgeLinkIconDisabled from "../../asset/image/linkDisabled.svg"
import { getEdgeServerStatus } from "../../actions/Users/graphQlServices";
import { USER_OU } from "../../constants/Constants";
import { checkLoggedInUserAuthorizedToViewPage, checkSelectedOuIsInvitedOu, convertDateTimeIntoTimezone, getDataFromLocalStorage, getDataFromLocalStorageParsed, getDecodeURI, getInvitedOuList, getTimezoneCity, handleValidateTier } from "../../utils/util";
import NameUpdate from "./NameUpdate";
import userEditImage from "../../asset/image/user_edit.svg";
import HA_icon from "../../asset/image/High_Availability.svg";
import { vesselAddressMMSI } from "../../actions/Users/authenticateService"
import { clearData, getGeneratedLinks } from "../RemoteConnections/remoteConnectionSlice";
import { displayToastError } from "../../server/request";
import { CONFIRM_DIALOG_TITLE, SERVICE_FUNCTION_TO_FEATURE } from "../../config";
import { getOrganisationUnitList, updateUserOuHasSubOus } from "../../actions/Users/authenticate";
import { backupConfigNow, rebootDevice } from "../../actions/Users/authenticateInventory";
import { getSearchDidsData } from '../../actions/Users/authenticateOpenEdgeService';
import { GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS, GET_SEARCH_DIDS, TRACK_INVENTORY_SYNC_DATA } from '../../actions/types';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { compare } from "compare-versions";
import RotateRightOutlinedIcon from '@mui/icons-material/RotateRightOutlined';
import SoftwareUpgrade from "../InventoryDeployedTable/SoftwareUpgrade";
import { GET_HIGH_AVAILABILITY_DEVICE, GET_UPGRADE_INVENTORY_LICENSE, GET_INVENTORY_DEPLOYED_DATA} from "../../actions/types";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { getHighAvailabilityDevice, highAvailability } from "../../actions/Users/authenticateHighAvailability";
import UpdatesGoingOn from "../../asset/image/updates_going_on.svg";
import ManageConfigLogs from "./ManageConfigLogs";
import EditActionsPopup from "../InventoryDeployedTable/EditActionsPopup";
import CustomisedJsonDataTooltip from "../../UserScreen/ThreatDashboard/ThreatsComponent/CustomisedTooltip";
import {getFlightScheduleData} from "../../actions/Users/authenticateDashboard";
import { T103_TIER } from "../InventoryDeployedTable";
import ArrowCircleDownIcon from '@mui/icons-material/ExpandMore';
import ArrowCircleUpIcon from '@mui/icons-material/ExpandLess';
import InventoryPopup from "./../../UserScreen/InventoryPage/InventorySettings/InventoryPopup";
import { DEFAULT_PAGE_SIZE, NEW_PER_PAGE_ITEMS } from "../../constants/Constants";
import EditHighAvailability from "./EditHighAvailability";
import ManageHALogs from "./ManageHALogs";

const VesselSummary: any = (props) => {
    const { authReducer, selectedVessel, selectedVesselName, getEdgeServerStatus, location, updateVesselName, vesselAddressMMSI, getGeneratedLinks, backupConfigNow, rebootDevice , isReadOnlyUser, getFlightScheduleData, flightScheduledata, tailId, upgradeInventoryLicense, getSearchDidsData, highAvailability } = props;
    let [products, setProducts]: any = useState([]);
    let _q = getDecodeURI(location?.search);
    let [productsArray, setProductsArray]: any = useState([]);
    const [selectedProductId, setSelectedProductId] = useState<string>("");
    const [selectedDeviceId, setSelectedDeviceId] = useState<string>("");
    const [openUpdateSiteName, setOpenUpdateSiteName] = useState(false);
    const [openUpdateProductName, setOpenUpdateProductName] = useState(false);
    const [clickedProductName, setClickedProductName] = useState("");
    const [clickedProductId, setClickedProductId] = useState("");
    const [clickedProductDevices, setClickedProductDevices] = useState<any[]>([])
    const [k4Id, setK4Id] = useState("")
    const [ouId, setOuId] = useState("")
    const [ouName, setOuName] = useState("")
    const [editActionsPopup, setEditActionsPopup] = useState(false);
    const [editActionRow, setEditActionRow] = useState<any>({});
    const [isOpenEdgeDevice, setIsOpenEdgeDevice] = useState<boolean>(false)
    const [selectedRow, setSelectedRow] = useState<any>({});
    const dispatch = useDispatch();

    const isAuthorizedToBeta= checkLoggedInUserAuthorizedToViewPage(SERVICE_FUNCTION_TO_FEATURE["beta-feature"]["service"], SERVICE_FUNCTION_TO_FEATURE["beta-feature"]["function"]);
    const [isSelectedOuIsUserOu, setIsSelectedOuIsUserOu] = useState(false)
    const [invitedOus, setInvitedOus] = useState<any[]>([])

    const [count, setCount] = useState<number>(0);
    const [flightScheduleTable, setFlightScheduletable] = useState<any[]>([])
    const [upgradeLicensePayload, setUpgradeLicensePayload] = useState<any>({});
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
        onConfirm: {},
    });
    const [deviceDetailsOpen, setDeviceDetailsOpen] = useState<boolean>(true);
    const betaUser = (localStorage.getItem("isBetaUser") === "true");
    const [openHA, setOpenHA] = useState(false);
    const [selectedOption, setSelectedOption] = useState<string>('Primary');
    const [devicesId, setDeviceId] = useState<any>([]);
    const [errorObj, setErrorObj] = useState<boolean>(false);
    
    useEffect(() => {
        updateUserOuHasSubOus(authReducer)
        let invitedOuList = getInvitedOuList(authReducer.getOrganisationUnitList)
        setInvitedOus(invitedOuList)
    }, [authReducer.getOrganisationUnitList])

    useEffect(() => {
        if (!_.isEmpty(authReducer.selectedOu) && authReducer.selectedOu.hasOwnProperty("id") && authReducer.selectedOu.id
            && authReducer.selectedOu.hasOwnProperty("name") && authReducer.selectedOu.name) {

            let isSelectedOuIsInvitedOu = checkSelectedOuIsInvitedOu(authReducer.selectedOu, invitedOus)
            setIsSelectedOuIsUserOu(!isSelectedOuIsInvitedOu)
        }
    }, [authReducer.selectedOu]);

    useEffect(() => {
        if (invitedOus.length > 0) {
            let isSelectedOuIsInvitedOu = checkSelectedOuIsInvitedOu(authReducer.selectedOu, invitedOus)
            setIsSelectedOuIsUserOu(!isSelectedOuIsInvitedOu)
        }else {
            setIsSelectedOuIsUserOu(true)
        }
    }, [invitedOus])


    const createProductData = (k4Id, id, name, type = "-", hardwareVersion = "-", softwareVersion = "-", status = "-", devices = [], dp_name, ou_user, dpId, dpname, deviceName) => {
        return { k4Id, id, name, type, hardwareVersion, softwareVersion, status, devices, dp_name, ou_user, dpId, dpname, deviceName };
    }


    // useEffect(() => {
    //     if (products && products.length > 0) {
    //         let devicesArray: string[] = [];
    //         products.map((product) => {
    //             product.devices.map((pro) => {
    //                 devicesArray.push(pro.id)
    //                 //    return 
    //             })
    //         })
    //         getEdgeServerStatus(devicesArray)

    //     }
    // }, [products])

    // useEffect(() => {

    //     if (!_.isEmpty(authReducer.edgeServerStatus) && authReducer.edgeServerStatus.data) {
    //         let endpoint_status: any[] = authReducer?.edgeServerStatus?.data?.getVesselsEndPointStatusResponse?.endpoint_status;

    //         let _products = JSON.parse(JSON.stringify(products));
    //         for (let i = 0; i < _products.length; i++) {
    //             for (let j = 0; j < _products[i].devices.length; j++) {
    //                 let deviceId = _products[i].devices[j].id;
    //                 let status = "-"
    //                 let last_seen = "-";
    //                 for (let k = 0; k < endpoint_status.length; k++) {
    //                     if (deviceId === endpoint_status[k].name && endpoint_status[k].last_seen != null) {
    //                         {
    //                             status = endpoint_status[k].status;
    //                             last_seen = endpoint_status[k].last_seen.seconds;
    //                         }
    //                     }
    //                 }
    //                 _products[i].devices[j].status = status;
    //                 _products[i].devices[j].last_seen = last_seen;

    //             }
    //         }
    //         setK4Id(_products[0]?.k4Id)
    //         setProductsArray(_products)

    //         authReducer.vesselEdgeInfo = {};
    //     }
    // }, [authReducer.edgeServerStatus]);

    useEffect(() => {
        if(k4Id){
            vesselAddressMMSI(k4Id)
            highAvailability(selectedVessel);
        }
    }, [k4Id])

    useEffect(() => {
        if(selectedVessel && tailId && tailId !== "null" && tailId !== "undefined" && tailId !== "true" && tailId !== "false" && tailId.trim() !== ""){
            getFlightScheduleData(selectedVessel)
        }
    }, [selectedVessel, tailId])

    useEffect(() => {
        if(!_.isEmpty(flightScheduledata)) {
            const data = flightScheduledata?.hasOwnProperty('data') ? flightScheduledata?.data : {};
            const dataArr:any = [];
            data?.rows && data?.rows?.forEach((item, i) => {
                const itemArr = data?.columns?.reduce((acc, columItem, i) => {
                    acc[columItem] = item[i];
                    return acc;
                }, {})
                dataArr.push(itemArr)
            })
            setFlightScheduletable(dataArr);
        }
    }, [flightScheduledata])

    const flattenProducts = (products: any[]) => {
        const flattened: any[] = [];

        products.forEach(product => {
            if (Array.isArray(product.devices)) {
            product.devices.forEach(device => {
                flattened.push({
                ...product,
                ...device,
                });
            });
            } else {
            flattened.push({ ...product });
            }
        });

        return flattened;
    };


    useEffect(() => {
        if (!_.isEmpty(authReducer.getHighAvailabilityDevice)) {
            if (authReducer.getHighAvailabilityDevice.hasOwnProperty("status") && authReducer.getHighAvailabilityDevice.status === "ok") {
                if (authReducer.getHighAvailabilityDevice.hasOwnProperty("data") && Array.isArray(authReducer.getHighAvailabilityDevice.data.manage_location)  &&  authReducer.getHighAvailabilityDevice.data.manage_location.length > 0 ) {
                    let data = authReducer.getHighAvailabilityDevice.data;
                    let dp_name = data.name;
                    setOuId(data.id)
                    setOuName(dp_name);
                    const _userOu: any = getDataFromLocalStorage(USER_OU);
                    let userOu: any = _userOu ? JSON.parse(_userOu) : {};
                    if (data && data.hasOwnProperty("manage_location") && Array.isArray(data.manage_location) && data.manage_location.length > 0) {
                        let _products: Array<Object> = data.manage_location[0].products && data.manage_location[0].products.map((product) => {
                            let k4Id = product.hasOwnProperty(LOCATION_ID_KEY) ? product[LOCATION_ID_KEY] : "";
                            setK4Id(k4Id)
                            let deviceId = product.hasOwnProperty(ID_KEY) ? product[ID_KEY] : "";
                            let device_name = product.hasOwnProperty(NAME_KEY) ? product[NAME_KEY] : "-";
                            let deviceName = product.hasOwnProperty(NAME_KEY) ? product[NAME_KEY] : "-";
                            let device_type = product.hasOwnProperty(TYPE_KEY) ? product[TYPE_KEY] : "-";
                            let hardwareVersion = product.hasOwnProperty(HARDWARE_VESION_KEY) ? product[HARDWARE_VESION_KEY] : "-";
                            let device_softwareVersion = product.hasOwnProperty(SOFTWARE_VERSION_KEY) ? product[SOFTWARE_VERSION_KEY] : "-";
                            let device_status = product.hasOwnProperty(STATUS) ? product[STATUS] : "-";
                            let devices = product.hasOwnProperty("devices") ? product["devices"] : [];

                            for (let i = 0; i < devices.length; i++) {
                                let device = devices[i]
                                device["is_current_EOS_version_above_v6.5.3"] = false
                                device["last_seen"] = device?.konnectLastSeen != "" ? convertDateTimeIntoTimezone(device.konnectLastSeen, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : device?.ascentModemLastSeen ? convertDateTimeIntoTimezone(device.ascentModemLastSeen, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS): "-"
                                device["konnect_status"] = device?.konnectStatus
                                device["inprogressFlag"] = 0
                                device["deviceId"] = device?.id
                                if (device?.inprogress && device.inprogress =="1"){
                                    device["inprogressFlag"] = 1
                                }
                                device["action_status"] = device?.action_status
                                device["action"] = device?.action
                                device['uptime_date'] = device?.uptime_date;
                                device['productType'] = device?.systemType;
                                device['termDisplay'] = device?.termDisplay;
                                device['termValue'] = device?.termValue;
                                device['tierAlias'] = device?.tierAlias;
                                device['tierValue'] = device?.tierValue;
                                device['license_expiry_date'] = device?.license_expiry_date;
                                device['pausedOn'] = device?.pausedDate;
                                device['resumeDate'] = device?.resumeDate;
                                device['deRegisteredDate'] = device?.deRegisteredDate;

                                if (!_.isEmpty(device["id"]) && device.hasOwnProperty("softwareVersion") && !_.isEmpty(device.softwareVersion)) {
                                    let currentEOSversion = device.softwareVersion
                                    if (currentEOSversion.indexOf("~") > -1) {
                                        currentEOSversion = currentEOSversion.substring(0, currentEOSversion.indexOf("~"))
                                    }

                                    device["current_EOS_version"] = currentEOSversion
                                    try {
                                        device["is_current_EOS_version_above_v6.5.3"] = compare(currentEOSversion, '6.5.3', '>=')
                                        device["is_current_EOS_version_above_v6.5.2"] = compare(currentEOSversion, '6.5.2', '>=')
                                        device["is_current_EOS_version_above_v6.5.0"] = compare(currentEOSversion, '6.5.0', '>=')
                                    } catch (error) {
                                        console.log("error in version compare, current_EOS_version", device["current_EOS_version"])
                                    }
                                }
                            }

                            let dp_name = data.name;
                            let dpname = data.name;
                            let dpId = data.id;
                            let ou_user = userOu.name;
                            return createProductData(k4Id, deviceId, device_name, device_type, hardwareVersion, device_softwareVersion, device_status, devices, dp_name, ou_user, dpId, dpname, deviceName);
                        });
                        const flattened = flattenProducts(_products);
                        setProducts(flattened)
                        
                        const list = flattened?.map(product => product.id); 
                        getSearchDidsData(list);
                    }
                }
            } else {
                console.error("Error - getHighAvailabilityDevice() resposne: ", authReducer.getHighAvailabilityDevice);
            }
            setIsOpenEdgeDevice(false);
            setEditActionsPopup(false);
            dispatch({ type: GET_HIGH_AVAILABILITY_DEVICE, payload: {}})
        }
    }, [authReducer.getHighAvailabilityDevice]);

    useEffect(() => {
        if (!_.isEmpty(authReducer.getHighAvailabilityDevice)) {
            const arr: any = [];
            const validPrefixes = [
                "ES", "EP", "VX", "VH", "SK", "E4", "28", "NB", "EF", "AM",
                "0", "EN", "EC", "EB", "EA", "CH"
            ];
            const data = authReducer.getHighAvailabilityDevice;
            data?.data?.manage_location.forEach((e) => {
                e.products?.forEach((product) => {
                    product.devices?.forEach((id) => {
                        if (id.id && validPrefixes.some(prefix => id.id.startsWith(prefix))) {
                            arr.push(id.name + ' | ' + id.id);
                        }
                    })
                })
            })
            setDeviceId(arr)
        }
    }, [authReducer.getHighAvailabilityDevice])

    useEffect(() => {
        const routerDIDs = authReducer?.getSearchDids?.router_dids || [];
        const apDIDs = authReducer?.getSearchDids?.ap_dids || [];

        if (products?.length && (routerDIDs?.length || apDIDs?.length)) {
            const updatedProducts = products.map((product: any) => {
                let mode = "";

                if (routerDIDs.includes(product.deviceId)) {
                    mode = "router";
                } else if (apDIDs.includes(product.deviceId)) {
                    mode = "ap";
                    product['disabled_portal'] = betaUser ? false : true;
                }
                if(product['tierAlias'] == 'Essential') {
                    product['disabled_portal'] = true;
                }

                return { ...product, mode };
            });

            setProducts(updatedProducts);
            dispatch({ type: GET_SEARCH_DIDS, payload: {} })
        }
    }, [products, authReducer.getSearchDids]);


    const updateDeviceInfo = (productName, productId, productDevices) => {
        setClickedProductName(productName);
        setClickedProductId(productId);
        setClickedProductDevices(productDevices);
        setOpenUpdateProductName(true);
    }
    
    useEffect(()=>{
        if(!openUpdateProductName){
            setClickedProductName("");
            setClickedProductId("");
            setClickedProductDevices([]);
        }
    },[openUpdateProductName])
    const EDGE_PORTAL_ADDRESS = "127.0.0.1";
    const EDGE_PORTAL_PORT = 80;

    const onConnectToEdge = async ( deviceId: any) => {
        // e.preventDefault()
        let resp = await getGeneratedLinks(selectedVessel, deviceId, { address: [EDGE_PORTAL_ADDRESS] })
        if (!_.isEmpty(resp?.result)) {
            let [edgeLink] = resp.result?.filter(rc => {
                return rc?.address === EDGE_PORTAL_ADDRESS && rc.port === EDGE_PORTAL_PORT && rc.alias.includes("Portal")
            });
            if (edgeLink && edgeLink.url) {
                let url = edgeLink.url;
                const loggedInUser = getDataFromLocalStorageParsed("loggedInUser");
                let edgeToken = loggedInUser?.data?.edge_token;
                if (!_.isEmpty(edgeToken)) {
                    let objUrl = new URL(`/login?token=${edgeToken}`, `${url}`)
                    url = objUrl?.href
                }
                window.open(url)
                clearData()
            }
        } else {
            displayToastError('No remote connection link found')
        }
    }

    const handleEditAction = (device) => {
        // Check the device is Open Edge by verifying the device's prefix "RS" or "RM"
        let isOpenEdge = device?.id?.startsWith("RS") || device?.id?.startsWith("RM") || false
        setIsOpenEdgeDevice(isOpenEdge)
        if(!isOpenEdge) {setEditActionsPopup(true);}
        const rowData = {
            action: device?.action,
            action_status: device?.action_status,
            current_EOS_version: device?.current_EOS_version,
            deviceId: device?.id,
            deviceName: device?.name,
            dpId: ouId,
            dpname: ouName,
            inprogressFlag: device?.inprogressFlag,
            "is_current_EOS_version_above_v6.5.0": device["is_current_EOS_version_above_v6.5.0"],
            "is_current_EOS_version_above_v6.5.2": device["is_current_EOS_version_above_v6.5.2"],
            "is_current_EOS_version_above_v6.5.3": device["is_current_EOS_version_above_v6.5.3"],
            k4Id: k4Id,
            konnect_status: device?.konnectStatus,
            last_seen: device?.last_seen,
            latestEOSavailable: device?.latestEOSavailable,
            licenseType: device?.licenseType,
            name: selectedVesselName,   //siteName
            productType: device?.type,
            sn: device?.id,
            licenseTier: device?.licenseTier,
            mode: device?.mode,
            termDisplay: device?.termDisplay,
            termValue: device?.termValue,
            tierAlias: device?.tierAlias,
            tierValue: device?.tierValue,
            license_expiry_date: device?.license_expiry_date,
            pausedOn: device?.pausedOn,
            resumeDate: device?.resumeDate,
            deRegisteredDate: device?.deRegisteredDate,
        };
        setSelectedRow(rowData);
        setEditActionRow(rowData);
    }
    useEffect(() => {
        if (!_.isEmpty(authReducer.inventoryAssignDeviceToWarehouse)) {
            const res = authReducer.inventoryAssignDeviceToWarehouse;
            if (res?.message && (res?.error_code == 10011 || res?.error_code == 10035 || res?.error_code == 10015 || res?.error_code == 10055 || res?.error_code == 10056)) {
            } else if(res.hasOwnProperty("status") && res.status == 1) {
                setEditActionsPopup(false);
                setConfirmDialog({...confirmDialog, isOpen: false, subTitle: ''})
                setIsOpenEdgeDevice(false);
            } else {
                setEditActionsPopup(false);
                setIsOpenEdgeDevice(false);
                setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
            }
            authReducer.inventoryAssignDeviceToWarehouse = {}
        }
    }, [authReducer.inventoryAssignDeviceToWarehouse])

    const handleActionClick = (
        type: "setting" | "refresh" | "delete" | "portal" | "edit" | "update_HA",
        headerKey: string,
        row: NetworkTableRow
    ) => {
        switch (type) {
        case "edit":
            updateDeviceInfo(row.name, row.id, row.device);
            break;
        case "setting" : 
            handleEditAction(row);
            dispatch({type: TRACK_INVENTORY_SYNC_DATA, payload: {}});
            dispatch({ type: GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS, payload: {} });
            break;
        case "portal" : 
            if (row?.disabled_portal) {
                return;
            } 
            switch(row?.konnect_status){
                case "STATUS_CONNECTED":
                     onConnectToEdge(row.id);
                     break;
                case "STATUS_NOT_FOUND":
                    break;
            }
            break;
        case "update_HA": {
            setOpenHA(true);
            break;
        }
        default:
            console.warn(`Unhandled action type: ${type}`);
        }
    };
    const REG_DATE = "dateRegistered"
    const ASC_ORDER = "asc";
    const DESC_ORDER = "desc";
    const [page, setPage] = useState<any>(_q.hasOwnProperty("page") ? parseInt(_q.page) : 0);
    const [limit, setLimit] = useState<any>(_q.hasOwnProperty("limit") ? _q.limit : DEFAULT_PAGE_SIZE);
    const [sort, setSort] = useState<any>(_q.hasOwnProperty("sort") ? _q.sort : REG_DATE);
    const [sortOrder, setSortOrder] = useState<any>(_q.hasOwnProperty("sortOrder") ? _q.sortOrder : DESC_ORDER);
    const [selectedOu, setSelectedOu ] = useState<any>(_q.hasOwnProperty("ouName") && _q.ouName!=="K4Mobility" ? `and fullname IN ('${_q.ouName}')` : "");
    let [searchValue, setSearchValue] = useState<any>(_q.hasOwnProperty("search") ? _q.search : "");
    const [locationIds, setLocatioIds] = useState([]);
    let deregQFromUrl = _q.deregQ ? decodeURIComponent(_q.deregQ).trim() : "";
    const [isDeregQueueChecked, setIsDeregQueueChecked] = useState(false);
    const [selectedTab, setSelectedTab] = useState('Device');
    const [columns, setColumns] = useState<any>([
        // {
        //   label: "",
        //   key: "active",
        //   type: ColumnType.conditional,
        //   maxWidth: "41px",
        // },
        {
          label: "Device Name",
          key: "name",
          type: ColumnType.editableText,
          maxWidth: "108px",
        },
        {
          label: "Device Id (DID)",
          key: "id",
          type: ColumnType.text,
          maxWidth: "100px",
        },
        // {
        //   label: "Link State",
        //   key: "test",
        //   type: ColumnType.text,
        //   maxWidth: "102px",
        // },
        {
          label: "Software",
          key: "current_EOS_version",
          type: ColumnType.text,
          maxWidth: "89px",
        },
        {
          label: "Status",
          key: "konnect_status",
          type: ColumnType.onlineOffline,
          onlineOfflineList: [{
                iconId: "greenDotSymbol",
                statusText: "Online"
            },
            {
                iconId: "redDotSymbol",
                statusText: "Offline"
            }],
          maxWidth: "89px",
        },
        {
          label: "Last Seen",
          key: "last_seen",
          type: ColumnType.text,
          maxWidth: "89px",
        },
        (!isReadOnlyUser && localStorage.getItem("readOnlyAceess")!== undefined && !(localStorage.getItem("readOnlyAceess") == "true") || localStorage.getItem("readOnlyAceess") == "true") && {
          label: "Portal",
          key: "custom",
          type: ColumnType.actions,
          actions: ["portal"],
          maxWidth: "68px",
        },
        {
          label: "Operations",
          key: "custom",
          type: ColumnType.actions,
          actions: ["setting"],
          maxWidth: "68px",
        },
      ])

    useEffect(() => {
        if (editActionRow?.mode === 'ap') {
            const updatedColumns = columns.filter(col => col.label !== 'Actions');
            setColumns(updatedColumns);
        }
    }, [editActionRow])

    useEffect(() => {
        if (!_.isEmpty(authReducer.highAvailability) && !_.isEmpty(products)) {
            const data = authReducer.highAvailability;
            setErrorObj(authReducer.highAvailability.hasOwnProperty('data') && authReducer.highAvailability.data.hasOwnProperty('errors'))

            const { primary_device, secondary_device, serving_device, primary_device_name, secondary_device_name } = data;

            if (!primary_device || !secondary_device || !serving_device){
                setProducts(prev =>
                    prev.map(item => ({
                        ...item,
                        primary_device_name: "",
                        secondary_device_name: "",
                        serving_device: "",
                        show_ha_icon: false
                    }))
                );
                return;
            }
            const matchedDevices = [primary_device, secondary_device];

            const enrichedProducts = products.map((product) => ({
                ...product,
                serving_device,
                primary_device_name: `${primary_device_name} | ${primary_device}`,
                secondary_device_name: `${secondary_device_name} | ${secondary_device}`,
                serving_device_name: serving_device === primary_device ? `${primary_device_name} | ${serving_device}` : `${secondary_device_name} | ${serving_device}`,
                show_ha_icon: matchedDevices.includes(product.id),
            }));
            setSelectedOption(serving_device === primary_device ? "Primary" : "Secondary");
            const orderedProducts = [
                ...enrichedProducts.filter((p) => p.id === serving_device),

                ...enrichedProducts.filter(
                    (p) =>
                        matchedDevices.includes(p.id) &&
                        p.id !== serving_device
                ),

                ...enrichedProducts.filter((p) => !matchedDevices.includes(p.id)),
            ];

            setProducts(orderedProducts);
            dispatch({ type: GET_HIGH_AVAILABILITY_DEVICE, payload: {} });
        }
    }, [authReducer.highAvailability]);

    return (
        <Grid className="vessel_summary_page white-bg">
            <div style={{padding: "10px 14px"}}>
                <Grid className="siteUpdate">
                    <Button className="marBtm20" onClick={() => setOpenUpdateSiteName(true)} > {selectedVesselName} </Button>
                    <img className="icon-cursor" src={userEditImage}
                        alt="Update site name" title="Update site name" onClick={() => setOpenUpdateSiteName(true)} />
                    <img className="icon-cursor High-Availability-Edit" src={HA_icon}
                        alt="HA" title="HA" onClick={() => setOpenHA(true)} />
                </Grid>
                <div className="topology-ou-name" >{ouName}</div>
                {
                    openUpdateSiteName ? <NameUpdate open={openUpdateSiteName}
                        k4Id={k4Id}
                        value='newLocationName'
                        type='Site'
                        nameId={selectedVessel} onNameUpdate={updateVesselName}
                        name={selectedVesselName} closeUpdatePopup={() => setOpenUpdateSiteName(false)} /> : null
                }
                {
                    openHA && <EditHighAvailability
                        open={openHA} 
                        setOpenHA={setOpenHA}
                        handleSave={() => setOpenHA(false)}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        selectedVessel={selectedVessel}
                        devicesIds={devicesId}
                        products={products}
                        errorObj={errorObj}
                    />
                }
            </div>
            {/* <div className="mmsi-streetAdrdess">
              <Grid className="MMSINumber"><span className="VesselMMSI">MMSI : </span>{ MMSIValue ? MMSIValue : "No data" }</Grid>
              <Grid className="streetAddressName"><span className="VesselMMSI">Street Address : </span> { streetAddress ? streetAddress : "No data" }</Grid>
            </div> */}
            {/* <UserCards wanLinkWidget={wanLinkWidget} uptimeWidget={uptimeWidget} vsatSpeedWidget={vsatSpeedWidget} lteSpeedWidget={lteSpeedWidget} vsatServicePlan={vsatServicePlan} lteServicePlan={lteServicePlan} kaasServicePlan={kaasServicePlan} isVesselOnline={isVesselOnline} /> */}
            <Grid container className="topology">
                {/* <Grid item xs={12} sm={12} md={5} lg={5} className="vessel_summary_topology_diagram">
                    <ToplogyView products={products} selectedVesselName={selectedVesselName} setSelectedNode={setSelectedNode}></ToplogyView>
                </Grid>

                < Grid item xs={12} sm={12} md={7} lg={7} className="vessel_summary_product_details"> */}
                < Grid item xs={12} sm={12} md={12} lg={12} className="vessel_summary_product_details scrollVesselDetail" style={{ padding: '10px' }}>
                    
                    {   <div className="deviceDetailsBoxshadow">
                        <div onClick={()=>{setDeviceDetailsOpen(!deviceDetailsOpen)}} className="deviceTableAccordian">
                            <span className="deviceDetailsHeading">Device Details</span>
                            {deviceDetailsOpen ? <ArrowCircleUpIcon className="marginLeftAuto"  /> : <ArrowCircleDownIcon className="starlinkMap-icon marginLeftAuto"  />}
                        </div>
                        {deviceDetailsOpen &&<NetworkTable 
                            data={products}
                            columns={columns}
                            onActionClick={handleActionClick}/>}
                        </div>
                        // products.map((product: any, i) => (
                        //     ("" === selectedProductId || selectedProductId === product.id) ?
                        //         [
                        //             <Grid className="vessel_summary_product" key={i}>

                        //                <div style={{ display: "inline !important" }}> 
                        //                <div className="vessel_summary_product_name productName">
                        //                     <span>{product.name}</span>
                        //                     <img className="icon-cursor deviceUpdate" src={userEditImage}
                        //                         alt="Update device name" title="Update device name" onClick={() => updateDeviceInfo(product.name, product.id, product.devices)} />
                        //                 </div>
                        //                 </div>
                        //                 <TableContainer>
                        //                     <Table aria-label="product_table" className="product_table">
                        //                         <TableHead>
                        //                             <TableRow >
                        //                                 <TableCell style={{ fontSize: "12px" }}>DID : {product.id}</TableCell>
                        //                                 {/* <TableCell style={{ fontSize: "12px" }}> Type : {product.type}</TableCell> */}
                        //                                 {/* <TableCell style={{ fontSize: "12px" }}> K4 Id : {product.k4Id}</TableCell> */}
                        //                             </TableRow>
                        //                         </TableHead>
                        //                     </Table>
                        //                 </TableContainer>
                        //             </Grid>,

                        //             product.devices && product.devices.length > 0 ?
                        //                 <Grid className="vessel_summary_product_device">
                        //                     {/*  */}

                        //                     <TableContainer className="alertsTable-FleetDashboard">
                        //                         <Table aria-label="simple table">
                        //                             <TableHead className="tableHead alertsTable-tableHead">
                        //                                 <TableRow className="alertReports-tableRow">
                        //                                     <TableCell className="alertsTable-fleetDataTable font-wt-900 width-20-percent border-right-topology">Device Name</TableCell>
                        //                                     <TableCell className="alertsTable-fleetDataTable font-wt-900 width-20-percent border-right-topology">DID</TableCell>
                        //                                     <TableCell className="alertsTable-fleetDataTable font-wt-900 width-12-percent border-right-topology">EOS Version</TableCell>
                        //                                     <TableCell className="alertsTable-fleetDataTable font-wt-900 width-12-percent border-right-topology">Konnect Status</TableCell>
                        //                                     <TableCell className="alertsTable-fleetDataTable font-wt-900 width-12-percent border-right-topology">Last Seen</TableCell>
                        //                                     {!isReadOnlyUser && localStorage.getItem("readOnlyAceess") !== "undefined" && !(localStorage.getItem("readOnlyAceess") == "true")  && <TableCell align="left" className="alertsTable-fleetDataTable width-12-percent font-wt-900 border-right-topology">Connect to Portal</TableCell>}
                        //                                     {!isReadOnlyUser && <TableCell className="alertsTable-fleetDataTable font-wt-900 width-12-percent border-right-topology">Operations</TableCell>}
                        //                                     {localStorage.getItem("readOnlyAceess") == "true" && <TableCell align="left" className="alertsTable-fleetDataTable width-12-percent font-wt-900 border-right-topology">Connect to Portal</TableCell>}
                        //                                 </TableRow>
                        //                             </TableHead>
                        //                                 <TableBody className="tableBody alertsTable-tableBody">
                        //                                 {  product.devices.map((device: any, i) => (
                        //                                         ("" === selectedDeviceId || selectedDeviceId === device.id) ?
                        //                                             <TableRow className="alertsData-tabelRow">
                        //                                                 <TableCell className="alertsTable-tableCell width-20-percent">
                        //                                                     <span className="topology-device-name-with-warning-icon">
                        //                                                         <Tooltip title={device.name}><span>{device.name}</span></Tooltip>
                        //                                                         {
                        //                                                             device.hasOwnProperty("inprogressFlag") && device.inprogressFlag
                        //                                                             ? <span className="modify-config-icon warningIcon" title={(device?.action) + ":" + (!_.isEmpty(device.action_status) ? (device?.action_status.length > 1 ? device.action_status.charAt(0).toUpperCase() + device.action_status.slice(1) : device.action_status) : null)}>
                        //                                                                 <img src={UpdatesGoingOn} />
                        //                                                             </span>
                        //                                                             : null
                        //                                                         }
                        //                                                     </span>
                        //                                                 </TableCell>
                        //                                                 <TableCell className="alertsTable-tableCell width-20-percent">
                        //                                                 {device.id}
                        //                                                 </TableCell>
                        //                                                 <TableCell className="alertsTable-tableCell width-12-percent" title={device.hasOwnProperty("softwareVersion")? device.softwareVersion : null}>{device.hasOwnProperty("softwareVersion") ?(device.softwareVersion.indexOf("~") > -1 ? device.softwareVersion.substring(0, device.softwareVersion.indexOf("~")) : device.softwareVersion) : "-"}
                        //                                                 </TableCell>
                        //                                                 <TableCell className="alertsTable-tableCell width-12-percent">
                        //                                                 {device && device?.isAscentModem ?  "-" :
                        //                                                     device?.licenseTier === T103_TIER ? <span className="dot" id="greyDotSymbol"></span> :
                        //                                                     device.status == "STATUS_CONNECTED" ?
                        //                                                         <img src={onlineIcon} alt="Online" title="Edge Server Online" id="greenDotSymbol"/>
                        //                                                         : device.status == "-" ? 
                        //                                                         <span className="dot" id="greyDotSymbol"></span> 
                        //                                                        : <span className="dot" id="redDotSymbol"></span> 
                                                                                
                        //                                                     }
                        //                                                 </TableCell>
                        //                                                 <TableCell className="alertsTable-tableCell width-12-percent">
                        //                                                 {device?.isAscentModem && device?.ascentModemLastSeen ? convertDateTimeIntoTimezone(device.ascentModemLastSeen, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : device.last_seen !== '-' && device?.licenseTier !== T103_TIER ? convertDateTimeIntoTimezone(device.last_seen, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : '-'}</TableCell>     
                        //                                         {!isReadOnlyUser && localStorage.getItem("readOnlyAceess")!== undefined && !(localStorage.getItem("readOnlyAceess") == "true") &&  <TableCell className="alertsTable-tableCell width-12-percent">
                        //                                                 {device.status === "STATUS_CONNECTED" ?
                        //                                                         <a className="vessel_table_cell--portal_link" onClick={(e) => onConnectToEdge(e, device.id)}>
                        //                                                             <img src={EdgeLinkIcon} title="Portal" />
                        //                                                         </a>
                        //                                                         : device.status  === "STATUS_NOT_FOUND" ?
                        //                                                         <a style={{ textDecoration: "none", textAlign: 'center' }}>
                        //                                                               <img src={EdgeLinkIcon} title="Portal" />
                        //                                                               </a> : device?.isAscentModem ?  "-" :
                        //                                                                 <a style={{ textDecoration: "none", textAlign: 'center' }}>
                        //                                                                 <img src={EdgeLinkIconDisabled} title="Portal" />
                        //                                                         </a>
                        //                                                     }
                        //                                                 </TableCell>}
                        //                                                 {localStorage.getItem("readOnlyAceess") == "true" &&  <TableCell className="alertsTable-tableCell width-12-percent">
                        //                                                 {device.status === "STATUS_CONNECTED" ?
                        //                                                         <a className="vessel_table_cell--portal_link" onClick={(e) => onConnectToEdge(e, device.id)}>
                        //                                                             <img src={EdgeLinkIcon} title="Portal" />
                        //                                                         </a>
                        //                                                         : device.status  === "STATUS_NOT_FOUND" ?
                        //                                                         <a style={{ textDecoration: "none", textAlign: 'center' }}>
                        //                                                               <img src={EdgeLinkIcon} title="Portal" />
                        //                                                               </a> : device?.isAscentModem ?  "-" :
                        //                                                                 <a style={{ textDecoration: "none", textAlign: 'center' }}>
                        //                                                                 <img src={EdgeLinkIconDisabled} title="Portal" />
                        //                                                         </a>
                        //                                                     }
                        //                                                 </TableCell>}
                        //                                                 {!isReadOnlyUser && <TableCell className="alertsTable-tableCell width-12-percent">
                        //                                                 <span onClick={() => handleEditAction(device) }> <SettingsIcon className="inventory-edit-icon" /> </span>
                        //                                             </TableCell>}
                        //                                                 </TableRow> : null
                        //                                     ))
                        //                                 }
                                                                
                        //                                 </TableBody>

                        //                         </Table>
                        //                     </TableContainer>
                        //                 </Grid>
                        //                 : null
                        //         ] : null
                        // ))
                    }  
                    { tailId && tailId !== "null" && tailId !== "undefined" && tailId !== "true" && tailId !== "false" && tailId.trim() !== "" ? 
                        <Grid className="vessel_summary_product_device flightTableMargin">
                            <div className="vessel_summary_product_name productName alignTopbarItemsCenter">
                                <span>{`Flight Details`}</span>
                            </div>
                            <TableContainer className="alertsTable-FleetDashboard">
                                <Table aria-label="simple table">
                                    <TableHead className="tableHead alertsTable-tableHead">
                                        <TableRow className="alertReports-tableRow">
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Flight No.</TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Tail Number</TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Origin </TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Destination </TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-12-percent border-right-topology">Depature Time</TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-12-percent border-right-topology">Arrival Time</TableCell>
                                            {/* <TableCell className="alertsTable-fleetDataTable font-wt-900 width-12-percent border-right-topology">Progress(%)</TableCell> */}
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Status</TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Route Distance</TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Aircraft Type</TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Airspeed </TableCell>
                                            <TableCell className="alertsTable-fleetDataTable font-wt-900 width-8-percent border-right-topology">Altitude </TableCell>
                                            {/* {!isReadOnlyUser && localStorage.getItem("readOnlyAceess") !== "undefined" && !(localStorage.getItem("readOnlyAceess") == "true")  && <TableCell align="left" className="alertsTable-fleetDataTable width-12-percent font-wt-900 border-right-topology">Connect to Portal</TableCell>}
                                            {!isReadOnlyUser && <TableCell className="alertsTable-fleetDataTable font-wt-900 width-12-percent border-right-topology">Operations</TableCell>}
                                            {localStorage.getItem("readOnlyAceess") == "true" && <TableCell align="left" className="alertsTable-fleetDataTable width-12-percent font-wt-900 border-right-topology">Connect to Portal</TableCell>} */}
                                        </TableRow>
                                    </TableHead>
                                    { flightScheduleTable && 0 != flightScheduleTable.length ? ( <TableBody className="tableBody alertsTable-tableBody">
                                      {flightScheduleTable.map((row: any, rowIndex: number) => (
                                      <TableRow className="alertsData-tabelRow">
                                        <TableCell className="alertsTable-tableCell width-20-percent">{row.ident}</TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{row.registration}</TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{JSON.parse(row.origin)?.code || "No data"}<CustomisedJsonDataTooltip 
                                        data={row.origin} /></TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{JSON.parse(row.destination)?.code || "No data"}<CustomisedJsonDataTooltip data={row.destination} /></TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{convertDateTimeIntoTimezone(row.scheduled_off, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{convertDateTimeIntoTimezone(row.scheduled_on, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</TableCell>
                                        {/* <TableCell className="alertsTable-tableCell width-20-percent">{row.progress_percent}</TableCell> */}
                                        <TableCell className="alertsTable-tableCell width-20-percent">{`${row.status} / ${row.progress_percent} %`}</TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{row.route_distance}</TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{row.aircraft_type}</TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{row.filed_airspeed}</TableCell>
                                        <TableCell className="alertsTable-tableCell width-20-percent">{row.filed_altitude}</TableCell>
                                      </TableRow>
                                      ))}
                                    </TableBody>)  :
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={8} align='center'>
                                                    No data available
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    }
                                    </Table>
                            </TableContainer>
                        </Grid> : <div></div>
                    }
                    {
                     
                        selectedTab == 'Device' ? <ManageConfigLogs selectedSite={selectedVessel} setSelectedTab={setSelectedTab} selectedTab={selectedTab} /> : <ManageHALogs selectedVessel={selectedVessel} setSelectedTab={setSelectedTab} selectedTab={selectedTab} />
                    
                    }
                </Grid>
                {
                    openUpdateProductName ? <NameUpdate value='deviceAliasName'
                        k4Id={""}
                        type='Device'
                        open={openUpdateProductName}
                        siteId={selectedVessel} nameId={clickedProductId} devices={clickedProductDevices} onNameUpdate={setClickedProductName}
                        name={clickedProductName} closeUpdatePopup={() => setOpenUpdateProductName(false)} /> : null
                }
            </Grid>
            {/* <Grid item >
                <Chart
                    chartOptions={firstChartoptions}
                    chartData={data} chartType={'Line'}
                    isRateEnabled={true}
                    ratesAndUsage={ratesAndUsage} />
            </Grid>
            <Grid>
                <Chart
                    chartOptions={secondChartOptions}
                    chartData={data} chartType={'Bar'}
                    isRateEnabled={false}
                    ratesAndUsage={{}} />
            </Grid> */}
            {
              (editActionsPopup && !isOpenEdgeDevice) ? <EditActionsPopup open={editActionsPopup} setOpen={setEditActionsPopup} row={editActionRow} isSelectedOuIsUserOu={isSelectedOuIsUserOu} confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} setRow={setEditActionRow} isAuthorizedToBeta={isAuthorizedToBeta} isOpenEdgeDevice={isOpenEdgeDevice} handleValidateTier={handleValidateTier}/>: null
            }
            {isOpenEdgeDevice && <InventoryPopup open={isOpenEdgeDevice} setOpen={setIsOpenEdgeDevice} row={selectedRow} deviceName={selectedRow['name']} isValidTier={handleValidateTier(selectedRow)} confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} topology={true} /> }
            
        </Grid>
    );
}

const DeviceNameCell = ({deviceName, deviceId}) => {
    const [openUpdateDeviceName, setOpenUpdateDeviceName] = useState(false);

    return <TableCell className="topology-tab-actions white-bg">
        <span className="marBtm20">{deviceName}</span>
    </TableCell>
}


const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    generatedLinks: state.remoteConnection.generatedLinks,
    isReadOnlyUser: state?.authReducer?.isReadOnlyUser,
    flightScheduledata: state?.authReducer?.flightSchedulingdata
});

export default withRouter(
    connect(mapStateToProps, {
        getVesselEdgeTopologyProducts,
        getEdgeServerStatus,
        vesselAddressMMSI,
        getGeneratedLinks,
        clearData,
        getOrganisationUnitList,
        backupConfigNow,
        rebootDevice,
        getHighAvailabilityDevice,
        getFlightScheduleData,
        getSearchDidsData,
        highAvailability
    })(VesselSummary)
);